import {
    LendingReturnPackageVolumeHourDayHeatmapChart as LendingReturnPackageVolumeHourDayHeatmapChartRenderer,
    hasChartSeries
} from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../heatmap-cell-summary/use-insight-heatmap-cell-click';
import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLendingReturnPackageVolumeHourDayHeatmapChart } from './use-lending-return-package-volume-hour-day-heatmap-chart';

export interface LendingReturnPackageVolumeHourDayHeatmapChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const LendingReturnPackageVolumeHourDayHeatmapChart = ({ accountId, width }: LendingReturnPackageVolumeHourDayHeatmapChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading, rangeStart, dayCount } = useLendingReturnPackageVolumeHourDayHeatmapChart(accountId);
    const title = (
        <FormattedMessage
            id='platform.analytics.insights.lending-return-package-volume-hour-of-day-bar-chart.title'
            description='Title for the lending return hour-of-day peaks chart on analytics insights'
            defaultMessage='Peak return windows'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId,
        chartKey: LendingReturnPackageVolumeHourDayHeatmapChartRenderer.definition.key,
        title
    });

    return (
        <InsightCard
            insightId={InsightId.LENDING_PEAK_RETURN_WINDOWS}
            chartKey={LendingReturnPackageVolumeHourDayHeatmapChartRenderer.definition.key}
            width={width}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.lending-return-package-volume-hour-day-heatmap-chart.subtitle'
                    description='Subtitle on the lending return heatmap indicating the chart covers the last 14 days'
                    defaultMessage='last 14 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div
                    className='w-full min-w-0 overflow-hidden'
                    style={{ height: chartMinHeight }}>
                    <LendingReturnPackageVolumeHourDayHeatmapChartRenderer
                        data={data}
                        rangeStart={rangeStart}
                        dayCount={dayCount}
                        minHeight={chartMinHeight}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </InsightCard>
    );
};
